module.exports = __webpack_public_path__ + "img/retim-kapasite-3.dd1d4c52.png";